import React from 'react';
import PropTypes from 'prop-types';
import { legShape } from 'constants/propTypes';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { FormattedMessage } from 'react-intl';
import { ChevronDown, ChevronUp } from 'react-feather';
import { Column } from 'components/shared/Layout';
import { DirectionContainer, StyledJourneySummaryHeader, Text } from '../JourneyDigest.styles';

const DigestHeader = ({ onClick, open, isReturnJourney, outbound, inbound, currency, total, totalPoints, isAllJourneysSelected }) => {
  const Chevron = open ? ChevronDown : ChevronUp;

  const showSegmentTitle = (segment) => !!segment && isReturnJourney;

  return (
    <StyledJourneySummaryHeader columns={4} onClick={onClick} data-cy="toggle-summary" isHighlighted={isAllJourneysSelected}>
      <Column span={1} alignItems="center">
        <Text underline>{open ? <FormattedMessage id="journeySummary.seeLess" /> : <FormattedMessage id="journeySummary.seeMore" />}</Text>
        <Chevron />
      </Column>

      <DirectionContainer span={1} justifyContent="flex-end" alignItems="center" show={isReturnJourney}>
        {showSegmentTitle(outbound) && <FormattedMessage id="journeySummary.outbound" />}
      </DirectionContainer>

      <DirectionContainer alignItems="center" span={1}>
        {showSegmentTitle(inbound) && <FormattedMessage id="journeySummary.inbound" />}
      </DirectionContainer>

      <Column alignItems="center" span={1} justifyContent="flex-end">
        <Text weight="bold">
          <FormattedMessage id="journeySummary.total" />
        </Text>
        &nbsp;
        <Text weight={300}>
          <FormattedCurrency currency={currency} amount={total} />
          {!!totalPoints && (
            <span data-id="journey-points-total">
              <> + </>
              <FormattedMessage id="searchResults.pts" values={{ points: totalPoints }} />
            </span>
          )}
        </Text>
      </Column>
    </StyledJourneySummaryHeader>
  );
};

DigestHeader.propTypes = {
  onClick: PropTypes.func,
  open: PropTypes.bool,
  isReturnJourney: PropTypes.bool,
  outbound: legShape,
  inbound: legShape,
  currency: PropTypes.string,
  total: PropTypes.number,
  totalPoints: PropTypes.number,
  isAllJourneysSelected: PropTypes.bool
};

export default DigestHeader;
